module.exports = __webpack_public_path__ + "img/project1.e0c2f00c.png";